import { render, staticRenderFns } from "./SearchGroup.vue?vue&type=template&id=bd605d00&scoped=true&"
import script from "./SearchGroup.vue?vue&type=script&lang=js&"
export * from "./SearchGroup.vue?vue&type=script&lang=js&"
import style0 from "./SearchGroup.vue?vue&type=style&index=0&id=bd605d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd605d00",
  null
  
)

export default component.exports